export default function Integer() {}
export function isInteger(x) {
  // https://stackoverflow.com/questions/14636536/how-to-check-if-a-variable-is-an-integer-in-javascript
  return (x | 0) === x;
}
//# sourceMappingURL=Integer.js.map


//////////////////
// WEBPACK FOOTER
// ./~/read-excel-file/modules/types/Integer.js
// module id = 389
// module chunks = 1